"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCard = void 0;
const key_1 = require("../../../utils/key");
const debounce_1 = require("../../../utils/debounce");
const dom_1 = require("../../../utils/dom");
const card_1 = require("../card/card");
const utils_1 = require("../../../utils/utils");
const check_media_1 = require("../../../utils/check-media");
const QUICK_VIEW_BUTTON_SELECTOR = '[data-product-card-quick-view-button]';
const VARIANT_CHOOSE_BUTTONS_SELECTOR = "[data-product-card-variant-selection]";
const PRELOADER_SELECTOR = '[data-product-card-preloader]';
const BUTTONS_SELECTOR = '[data-product-card-buttons]';
const FEATURED_MEDIA_SELECTOR = '[data-product-card-featured-image]';
const COLOR_SWATCHES_SELECTOR = '[data-product-card-color-swatches]';
const INNER_SELECTOR = '[data-product-card-inner]';
const QUICK_VIEW_SELECTOR = '#Quick-view';
const MAIN_MEDIA_SELECTOR = '[data-main-media]';
const VARIANT_PICKER_DRAWER_TOGGLES_SELECTOR = '[data-toggle-variant-picker-drawer]';
class ProductCard extends card_1.Card {
    resizeObserver;
    buttonsWidth = 0;
    buttonsHeight = 0;
    carouselInited;
    playingVideo;
    mountComponent() {
        const variantChooseButtons = (0, utils_1.$list)(VARIANT_CHOOSE_BUTTONS_SELECTOR, this);
        const variantPickerDrawerToggles = (0, utils_1.$list)(VARIANT_PICKER_DRAWER_TOGGLES_SELECTOR, this);
        const quickViewBtn = (0, utils_1.$el)(QUICK_VIEW_BUTTON_SELECTOR, this);
        const featuredImages = (0, utils_1.$list)(FEATURED_MEDIA_SELECTOR, this);
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(this);
        featuredImages.forEach(featuredImage => {
            if (featuredImage.complete ||
                featuredImage.readyState === 4 ||
                featuredImage.tagName === 'IFRAME') {
                this.handleMediaLoad();
            }
            else {
                this.addListener(featuredImage, 'load', this.handleMediaLoad);
                this.addListener(featuredImage, 'loadeddata', this.handleMediaLoad);
            }
        });
        this.addListener(quickViewBtn, 'click', this.handleQuickViewBtnClick);
        this.addListener(quickViewBtn, 'keydown', this.handleQuickViewBtnKeyDown);
        this.addListener(this, 'mouseenter', this.handleProductCardEnter);
        this.addListener(this, 'mouseleave', this.handleProductCardLeave);
        variantChooseButtons.forEach(variantChooseButton => this.addListener(variantChooseButton, 'click', () => {
            this.handleVariantBtnClick(variantChooseButton);
        }));
        variantPickerDrawerToggles.forEach(variantPickerDrawerToggle => this.addListener(variantPickerDrawerToggle, 'click', () => {
            this.toggleVariantPickerDrawer(variantPickerDrawerToggle);
        }));
        this.initResponsiveImages();
        this.handleShowVariantPickerListOnDesktop();
    }
    initVideo = async (lazyVideo) => {
        const parentNode = lazyVideo.parentNode;
        const withAutoplay = lazyVideo.hasAttribute('with-autoplay');
        if (!parentNode) {
            return;
        }
        const video = lazyVideo.querySelector('video');
        video.load();
        const handleTouch = () => {
            if (video.paused && withAutoplay) {
                video.load();
                video.play();
            }
            this.removeListener(window, 'touchstart', handleTouch);
        };
        const handleCanPlay = () => {
            parentNode.replaceChild(video, lazyVideo);
            video.play();
            this.removeListener(video, 'canplaythrough', handleCanPlay);
        };
        this.addListener(video, 'canplaythrough', handleCanPlay);
        this.addListener(window, 'touchstart', handleTouch);
    };
    initResponsiveImages = () => {
        const responsiveImages = (0, utils_1.$list)('[data-src-desktop]', this);
        responsiveImages.forEach((img) => {
            const srcDesktop = img.getAttribute("data-src-desktop");
            const srcMobile = img.getAttribute("data-src-mobile");
            const src = window.innerWidth > 768 ? srcDesktop : srcMobile;
            img.src = src;
            img.setAttribute("data-loaded", "true");
        });
    };
    unmountComponent() {
        this.resizeObserver.disconnect();
    }
    handleQuickViewBtnKeyDown = async (event) => {
        if ((0, key_1.isEnterKey)(event)) {
            event.preventDefault();
            this.callQuickView(true);
        }
    };
    handleQuickViewBtnClick = async () => {
        this.callQuickView(true);
    };
    handleProductCardEnter = () => {
        const video = (0, utils_1.$el)('lazy-video', this);
        if (video) {
            this.initVideo(video);
        }
        this.callQuickView(false);
    };
    handleProductCardLeave = () => {
        const productCardInputToggle = (0, utils_1.$el)('.product-card__variant-select__toggle', this);
        if (productCardInputToggle) {
            productCardInputToggle.checked = false;
        }
    };
    handleVariantBtnClick = (variantChooseButton) => {
        const inputRelated = (0, utils_1.$el)(`input#${variantChooseButton.getAttribute('for')}`, this);
        inputRelated?.click();
        const variantId = inputRelated?.getAttribute('value');
        if (!variantId)
            return;
        const form = inputRelated.closest('form');
        if (!form)
            return;
        form.dispatchEvent(new CustomEvent('lbc-submit', { bubbles: true, detail: { button: variantChooseButton } }));
    };
    async callQuickView(withOpen) {
        const quickView = (0, utils_1.$el)(QUICK_VIEW_SELECTOR);
        const url = this.dataset.url;
        const id = this.dataset.id;
        if (!quickView || !url || !id) {
            return;
        }
        await quickView.requestProductFromUrl(url, id);
        if (withOpen) {
            this.setQuickViewLoading(true);
            await quickView.openAndRenderProductByUrl(url);
            this.setQuickViewLoading(false);
        }
    }
    handleResize = (0, debounce_1.debounce)(() => {
        const buttons = (0, utils_1.$el)(BUTTONS_SELECTOR, this);
        const swatches = (0, utils_1.$el)(COLOR_SWATCHES_SELECTOR, this);
        if (buttons) {
            this.setButtonsOverflow();
        }
        if (swatches) {
            swatches.update();
        }
        if ((0, check_media_1.isMobile)()) {
            this.initMobileCarousel();
        }
    }, 250);
    handleMediaLoad = () => {
        const loader = (0, utils_1.$el)(PRELOADER_SELECTOR, this);
        (0, dom_1.hideElement)(loader);
    };
    handleShowVariantPickerListOnDesktop = () => {
        const variantPickerShowButton = (0, utils_1.$el)('[data-lbc-show-variant-picker]', this);
        const variantPickerList = (0, utils_1.$el)('.product-card__actions--variant-select', this);
        const productCardMainActions = (0, utils_1.$el)(".product-card__actions--with-variant-select .product-card__btns", this);
        if (!variantPickerShowButton || !variantPickerList || !productCardMainActions)
            return;
        variantPickerShowButton.addEventListener('click', () => {
            variantPickerList.classList.add('product-card__actions--variant-select--shown');
            productCardMainActions.style.transform = "translateY(100%)";
            const productCardInputToggle = (0, utils_1.$el)('.product-card__variant-select__toggle', this);
            if (productCardInputToggle) {
                productCardInputToggle.checked = true;
            }
        });
        this.addEventListener('mouseleave', () => {
            variantPickerList.classList.remove('product-card__actions--variant-select--shown');
            productCardMainActions.style.transform = "";
        });
    };
    initMobileCarousel = () => {
        if (this.carouselInited) {
            return;
        }
        const carousel = (0, utils_1.$el)('carousel-component', this);
        if (!carousel) {
            return;
        }
        const video = (0, utils_1.$el)('video', carousel);
        if (video) {
            carousel.embla?.on('select', this.handleCarouselSelect);
            this.carouselInited = true;
        }
    };
    handleCarouselSelect = (0, debounce_1.debounce)(async (embla) => {
        if (this.playingVideo) {
            this.playingVideo.pause();
            this.playingVideo = null;
        }
        let currentSlide = embla.slideNodes()[embla.selectedScrollSnap()].firstElementChild;
        if (currentSlide.tagName === 'VIDEO') {
            currentSlide.play();
            this.playingVideo = currentSlide;
        }
        else if (currentSlide.tagName === 'LAZY-VIDEO') {
            await this.initVideo(currentSlide);
            currentSlide = embla.slideNodes()[embla.selectedScrollSnap()].firstElementChild;
            // currentSlide.play()
            this.playingVideo = currentSlide;
        }
    }, 100);
    setButtonsOverflow() {
        const buttons = (0, utils_1.$el)(BUTTONS_SELECTOR, this);
        const inner = (0, utils_1.$el)(INNER_SELECTOR, this);
        if (!buttons) {
            return;
        }
        if (this.offsetWidth < this.buttonsWidth) {
            return;
        }
        const isWidthOverflow = buttons.offsetWidth > inner.offsetWidth;
        const isHeightOverflow = buttons.offsetHeight > inner.offsetHeight;
        if (isWidthOverflow && buttons.offsetWidth > this.buttonsWidth) {
            this.buttonsWidth = buttons.offsetWidth;
        }
        if (isHeightOverflow && buttons.offsetHeight > this.buttonsHeight) {
            this.buttonsHeight = buttons.offsetHeight;
        }
        buttons.classList.toggle('is-width-overflowed', isWidthOverflow);
        buttons.classList.toggle('is-height-overflowed', isHeightOverflow);
    }
    setQuickViewLoading(isLoading) {
        const quickViewBtn = (0, utils_1.$el)(QUICK_VIEW_BUTTON_SELECTOR, this);
        if (quickViewBtn) {
            quickViewBtn.classList.toggle('loading', isLoading);
            quickViewBtn.toggleAttribute('disabled', isLoading);
        }
    }
    getMainMedia() {
        return (0, utils_1.$el)(MAIN_MEDIA_SELECTOR, this);
    }
    async updateVariantPickerDrawer(btn) {
        const productUrl = btn.getAttribute('data-product-url');
        await fetch(productUrl + "?section=variant-picker-drawer")
            .then(response => response.text())
            .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            let variantPickerDrawerInMainHTML = document.querySelector('.variant-picker-drawer');
            if (variantPickerDrawerInMainHTML) {
                const headerTitle = variantPickerDrawerInMainHTML.querySelector('.variant-picker-drawer__header-title');
                const content = variantPickerDrawerInMainHTML.querySelector('.variant-picker-drawer__content');
                headerTitle.innerHTML = doc.querySelector('.variant-picker-drawer__header-title').innerHTML;
                content.innerHTML = doc.querySelector('.variant-picker-drawer__content').innerHTML;
            }
            else {
                document.body.insertAdjacentHTML('beforeend', doc.body.innerHTML);
            }
            variantPickerDrawerInMainHTML = document.querySelector('.variant-picker-drawer');
            const variantPickerDrawerToggles = variantPickerDrawerInMainHTML.querySelectorAll('[data-toggle-variant-picker-drawer]:not([data-toggle-variant-picker-drawer-initialized]');
            variantPickerDrawerToggles.forEach((toggle) => {
                toggle.setAttribute('data-toggle-variant-picker-drawer-initialized', '');
                toggle.addEventListener('click', () => {
                    this.toggleVariantPickerDrawer(toggle);
                });
            });
            const variantPickerDrawerOverlayInMainHTML = document.querySelector('.variant-picker-drawer__overlay:not([data-toggle-variant-picker-drawer-initialized]');
            if (variantPickerDrawerOverlayInMainHTML) {
                variantPickerDrawerOverlayInMainHTML.setAttribute('data-toggle-variant-picker-drawer-initialized', '');
                variantPickerDrawerOverlayInMainHTML.addEventListener('click', () => {
                    this.toggleVariantPickerDrawer(variantPickerDrawerOverlayInMainHTML);
                });
            }
            const variantPickerDrawerButtons = variantPickerDrawerInMainHTML.querySelectorAll('[data-product-card-variant-selection]');
            variantPickerDrawerButtons.forEach((variantPickerDrawerButton) => variantPickerDrawerButton.addEventListener('click', () => {
                this.handleVariantBtnClick(variantPickerDrawerButton);
            }));
            const variantPickerDrawerContent = variantPickerDrawerInMainHTML.querySelector('.variant-picker-drawer__content');
            const variantPickerDrawerContentInner = variantPickerDrawerInMainHTML.querySelector('.variant-picker-drawer__content__inner');
            // Check if the variant picker drawer content has overflow
            if (variantPickerDrawerContentInner.scrollHeight > variantPickerDrawerContentInner.clientHeight) {
                variantPickerDrawerContent.classList.add('variant-picker-drawer__content--with-overflow');
            }
            if (variantPickerDrawerContentInner) {
                variantPickerDrawerContentInner.addEventListener('scroll', () => {
                    if (variantPickerDrawerContentInner.scrollHeight - variantPickerDrawerContentInner.scrollTop === variantPickerDrawerContentInner.clientHeight) {
                        variantPickerDrawerContent.classList.remove('variant-picker-drawer__content--with-overflow');
                    }
                    else {
                        variantPickerDrawerContent.classList.add('variant-picker-drawer__content--with-overflow');
                    }
                });
            }
        });
    }
    async toggleVariantPickerDrawer(btn) {
        const uploadDrawer = btn.hasAttribute('data-update-variant-picker-drawer');
        if (btn.hasAttribute('data-btn-load-on-click')) {
            btn.classList.add("loading");
        }
        if (uploadDrawer) {
            await this.updateVariantPickerDrawer(btn);
        }
        const variantPickerDrawer = document.querySelector('.variant-picker-drawer');
        const variantPickerDrawerOverlay = document.querySelector('.variant-picker-drawer__overlay');
        if (variantPickerDrawer) {
            variantPickerDrawer.classList.toggle('variant-picker-drawer--open');
        }
        if (variantPickerDrawerOverlay) {
            variantPickerDrawerOverlay.classList.toggle('variant-picker-drawer__overlay--open');
        }
        if (btn.hasAttribute('data-btn-load-on-click')) {
            btn.classList.remove("loading");
        }
    }
}
exports.ProductCard = ProductCard;
